/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Download one document the client uploaded.
 * @summary Download Uploaded Document
 */
export const downloadUploadedDocument = (
    clientId: string,
    documentId: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<void>(
      {url: `/account-opening/clients/${clientId}/uploaded-documents/${documentId}/file`, method: 'GET', signal
    },
      options);
    }




export const getDownloadUploadedDocumentQueryKey = (clientId: string,
    documentId: string,) => {
    return [
    `/account-opening/clients/${clientId}/uploaded-documents/${documentId}/file`
    ] as const;
    }


export const getDownloadUploadedDocumentQueryOptions = <TData = Awaited<ReturnType<typeof downloadUploadedDocument>>, TError = HTTPValidationError>(clientId: string,
    documentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadUploadedDocument>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadUploadedDocumentQueryKey(clientId,documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadUploadedDocument>>> = ({ signal }) => downloadUploadedDocument(clientId,documentId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadUploadedDocument>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadUploadedDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadUploadedDocument>>>
export type DownloadUploadedDocumentQueryError = HTTPValidationError


/**
 * @summary Download Uploaded Document
 */

export function useDownloadUploadedDocument<TData = Awaited<ReturnType<typeof downloadUploadedDocument>>, TError = HTTPValidationError>(
 clientId: string,
    documentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadUploadedDocument>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadUploadedDocumentQueryOptions(clientId,documentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






